// 静态页
import AboutUs from "./staticPage/aboutUs/index";
import BillingRules from "./staticPage/billingRules/index";
import ChargeSecurityExplain from "./staticPage/chargeSecurityExplain/index";
import ChargeServiceExplain from "./staticPage/chargeServiceExplain/index";
import FindSourceGoods from "./staticPage/findSourceGoods/index";
import InvoiceConfirmation from "./staticPage/invoiceConfirmation/index";
import RechargeExplain from "./staticPage/rechargeExplain/index";
import RentCar from "./staticPage/rentCar/index";
import ServiceAgreenment from "./staticPage/serviceAgreenment/index";
import ServiceAgreenment2GuanChe from "./staticPage/serviceAgreenment2/index";
import Banner20191107 from "./staticPage/banner/20191107/index";
import Banner20191114 from "./staticPage/banner/20191114/index";
import Banner20211015 from "./staticPage/banner/20211015/index";
import Banner20230609 from "./staticPage/banner/20230609/index";
import huilian56 from "./staticPage/banner/20200506/index";
import UseCarRules from "./staticPage/useCarRules/index";
import CarAuthorization from "./staticPage/carAuthorization/index";
import PrivacyAgreement from "./staticPage/privacyAgreement/index";
import PrivacyAgreement2GuanChe from "./staticPage/privacyAgreement2/index";
import AccountCancellation from "./staticPage/accountCancellation/index";
import AccountCancellation2GuanChe from "./staticPage/accountCancellation2/index";
import ChargingVoucherRules from "./staticPage/chargingVoucherRules/index";
import GradeDescription from "./staticPage/gradeDescription/index";
import hd202112 from "./staticPage/hd202112/index";
// 绑车活动
import bindCehicleActivity from "./staticPage/bindCehicleActivity/index";
//应用权限说明
import PermissionDescribe from "./staticPage/permissionDescribe/index";
//第三方共享个人信息清单
import ThreeShareList from "./staticPage/threeShareList/index";
//资质证照清单
import CertificateList from "./staticPage/certificate/list/index";
//资质证照详情
import CertificateDetail from "./staticPage/certificate/detail/index";
// 慧运力介绍
import tmsAbout from "./staticPage/tmsAbout/index";
//应用版权信息
import CopyRight from "./staticPage/copyright/index";

// 通知信息notice
import notice from "./staticPage/notice/index";

// 小程序引流
import wxMiniDrainage from "./staticPage/wxMini/index";
// 个人信息授权须知
import personalInfoAuthNotice from "./staticPage/personalInfoAuthNotice/index";
// 第三方SDK清单
import listOfThirdSDK from "./staticPage/listOfThirdSDK/index";
// 第三方SDK清单慧管车
import listOfThirdSDKGuanChe from "./staticPage/listOfThirdSDKGuanChe/index";
// VIP充电会员服务协议
import chargingMemberServiceAgreement from "./staticPage/chargingMemberServiceAgreement/index";
// 慧建站
import HJZ from "./staticPage/HJZ/index";
// 远程慧联IOT
import remoteSmartLinkIOT from "./staticPage/remoteSmartLinkIOT/index";
// 硬服务
import hardServices from "./staticPage/hardServices/index";
// 软服务
import softServices from "./staticPage/softServices/index";
// 保值购
import hedged from "./staticPage/hedged/index";
// 程心购
import regular from "./staticPage/regular/index";
// 分离购
import separate from "./staticPage/separate/index";

export default [
  {
    path: "/AboutUs",
    component: AboutUs,
    title: "关于远程慧联",
  },
  {
    path: "/BillingRules",
    component: BillingRules,
    title: "开票规则",
  },
  {
    path: "/ChargeSecurityExplain",
    component: ChargeSecurityExplain,
    title: "充电安全须知",
  },
  {
    path: "/ChargeServiceExplain",
    component: ChargeServiceExplain,
    title: "慧联充电APP服务协议",
  },
  {
    path: "/FindSourceGoods",
    component: FindSourceGoods,
    title: "寻找货源",
  },
  {
    path: "/InvoiceConfirmation",
    component: InvoiceConfirmation,
    title: "申请开具增值税专用发票确认书",
  },
  {
    path: "/RechargeExplain",
    component: RechargeExplain,
    title: "充电卡购买协议",
  },
  {
    path: "/RentCar",
    component: RentCar,
    title: "我要租车",
  },
  {
    path: "/ServiceAgreenment",
    component: ServiceAgreenment,
    title: "用户协议",
  },
  {
    path: "/ServiceAgreenment2GuanChe",
    component: ServiceAgreenment2GuanChe,
    title: "远程慧联用户协议",
  },
  {
    path: "/Banner20191107",
    component: Banner20191107,
    title: "慧联智控APP使用教程",
  },
  {
    path: "/Banner20191114",
    component: Banner20191114,
    title: "慧联智控APP付租金送电费",
  },
  {
    path: "/Banner20211015",
    component: Banner20211015,
    title: "百日无违章挑战赛",
  },
  {
    path: "/Banner20230609",
    component: Banner20230609,
    title: "车辆随车手册",
  },
  {
    path: "/UseCarRules",
    component: UseCarRules,
    title: "用车须知",
  },
  {
    path: "/huilian56",
    component: huilian56,
    title: "狂欢56，任性到底",
  },
  {
    path: "/CarAuthorization",
    component: CarAuthorization,
    title: "车辆授权操作流程",
  },
  // 隐私协议----新增纯静态页面，此政策页后期注释
  {
    path: "/PrivacyAgreement",
    component: PrivacyAgreement,
    isLogin: false,
    isWxLogin: false,
    title: "远程慧联个人信息保护政策",
  },
  {
    path: "/PrivacyAgreement2GuanChe",
    component: PrivacyAgreement2GuanChe,
    isLogin: false,
    isWxLogin: false,
    title: "远程慧联个人信息保护政策",
  },
  // 注销协议
  {
    path: "/AccountCancellation",
    component: AccountCancellation,
    isLogin: false,
    isWxLogin: false,
    title: "远程慧联账号注销须知",
  },
  // 注销协议，慧管车
  {
    path: "/AccountCancellation2GuanChe",
    component: AccountCancellation2GuanChe,
    isLogin: false,
    isWxLogin: false,
    title: "慧管车账号注销须知",
  },
  // 优惠券使用规则
  {
    path: "/ChargingVoucherRules",
    component: ChargingVoucherRules,
    isLogin: false,
    isWxLogin: false,
    title: "使用规则",
  },
  // 会员说明
  {
    path: "/GradeDescription",
    component: GradeDescription,
    isLogin: false,
    isWxLogin: false,
    title: "会员说明",
  },
  {
    path: "/hd202112",
    component: hd202112,
    isLogin: false,
    isWxLogin: false,
    title: "充电优惠券使用教程",
  },
  // 绑车活动
  {
    path: "/bindCehicleActivity",
    component: bindCehicleActivity,
    isLogin: false,
    isWxLogin: false,
    title: "绑车活动",
  },
  //权限说明
  {
    path: "/PermissionDescribe",
    component: PermissionDescribe,
    title: "权限列表",
  },
  //三方共享个人信息清单
  {
    path: "/ThreeShareList",
    component: ThreeShareList,
    title: "第三方共享个人信息清单",
  },
  //资质证照清单
  {
    path: "/CertificateList",
    component: CertificateList,
    title: "资质证照清单",
  },
  {
    path: "/CertificateDetail",
    component: CertificateDetail,
    title: "资质证照详情",
  },
  {
    path: "/tmsAbout",
    component: tmsAbout,
    title: "关于慧运力",
  },
  {
    path: "/CopyRight",
    component: CopyRight,
    title: "版权信息",
  },
  {
    path: "/notice",
    component: notice,
    title: "通知",
  },
  {
    path: "/wxMiniDrainage",
    component: wxMiniDrainage,
    title: "慧联小助理",
  },
  {
    path: "/personalInfoAuthNotice",
    component: personalInfoAuthNotice,
    title: "个人信息授权须知",
  },
  {
    path: "/listOfThirdSDK",
    component: listOfThirdSDK,
    title: "第三方SDK清单",
  },
  {
    path: "/listOfThirdSDKGuanChe",
    component: listOfThirdSDKGuanChe,
    title: "第三方SDK清单",
  },
  {
    path: "/chargingMemberServiceAgreement",
    component: chargingMemberServiceAgreement,
    title: "VIP充电会员服务协议",
  },
  {
    path: "/HJZ",
    component: HJZ,
    title: "慧建站",
  },
  {
    path: "/iot",
    component: remoteSmartLinkIOT,
    title: "远程慧联IOT",
  },
  {
    path: "/hardServices",
    component: hardServices,
    title: "硬服务",
  },
  {
    path: "/hedged",
    component: hedged,
    title: "保值购",
  },
  {
    path: "/regular",
    component: regular,
    title: "程心购",
  },
  {
    path: "/separate",
    component: separate,
    title: "分离购",
  },
  {
    path: "/softServices",
    component: softServices,
    title: "软服务",
  },
];



// WEBPACK FOOTER //
// ./src/routeConfig.js